import { Location } from '@angular/common';

import { ChangeDetectorRef, Component, ElementRef, OnInit } from '@angular/core';

import axios from 'src/app/Service/axios';

import { NotificationService } from 'src/app/Service/notification.service';

import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { animate, state, style, transition, trigger } from '@angular/animations';

import { Router } from '@angular/router';

import { AudioRecordingService } from 'src/app/Service/audio-recording.service';

import { DomSanitizer } from '@angular/platform-browser';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

declare let $: any;

@Component({

  selector: 'app-manager-message',

  templateUrl: './manager-message.component.html',

  styleUrls: ['./manager-message.component.css'],

  animations: [

    trigger('fadeAnimation', [

      state('void', style({ opacity: 0 })),

      transition(':enter', [

        animate('300ms ease-in', style({ opacity: 1 }))

      ]),

      transition(':leave', [

        animate('100ms ease-out', style({ opacity: 0 }))

      ])

    ])

  ]

})

export class ManagerMessageComponent implements OnInit {

  list_Message: any = [];

  list_search: any = [];

  list_comments: any = [];

  list_Schools: any = [];

  audioManager: string | null = '';

  isLoading: boolean = false;

  searchT_School = '';

  filteredSchools = [];

  iMobileDomain: string = '';

  audioRecordedTime: any;

  audioBlobUrl: any;

  audioBlob: any;

  audioName: any;

  isAudioRecording: boolean = false;

  model: any = {};

  constructor(

    private location: Location,

    private formBuilder: FormBuilder,

    private notificationService: NotificationService,

    private Notification: NotificationService,

    private router: Router,

    private audioRecordingService: AudioRecordingService,

    private ref: ChangeDetectorRef,

    private sanitizer: DomSanitizer,

    private gurdService: GurdServiceService

  ) {

    this.audioRecordingService.recordingFailed().subscribe(() => {

      this.isAudioRecording = false;

      this.ref.detectChanges();

    });

    this.audioRecordingService.getRecordedTime().subscribe((time) => {

      this.audioRecordedTime = time;

      this.ref.detectChanges();

    });

  }

  ngOnInit(): void {

    this.getMessages();

    this.getSchools();

    this.audioRecordingService.getRecordedBlob().subscribe((data) => {

      var base64 = this.blobToBase64(data.blob);

      base64.then((result: any) => {

        this.model.strVoice_Base64 = result;

      });

      this.audioBlob = data.blob;

      this.audioName = data.title;

      this.audioBlobUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(data.blob));

      this.ref.detectChanges();

    });


  }

  async getMessages() {

    this.isLoading = true;

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    }

    let res = JSON.parse((await axios.post(`VoiceMessages_List`, model)).data.toString());

    this.list_Message = res;

    this.list_search = res;

    this.isLoading = false;

  }

  async showComment(item: any) {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iORGVoiceMessages: item.iORGVoiceMessages

    }

    let res = JSON.parse((await axios.post(`VoiceMessages_CommentList`, model)).data.toString());

    if (res.iResult == 0) return this.notificationService.showError(res.strError)

    this.list_comments = res;

    this.openModal('comments')

  }

  async deleteMessage(item: any) {

    $.confirm({

      title: `آیا از حذف این پیام اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {


            var model = {

              iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

              strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

              iORGVoiceMessages: item.iORGVoiceMessages
            }

            let res = JSON.parse((await axios.post(`VoiceMessages_Delete`, model)).data.toString());

            if (res.iResult == 0) return this.Notification.showError(res.strError);

            else {

              this.Notification.showSuccess('پیام با موفقیت حذف شد');

              const index = this.list_Message.indexOf(item);

              if (index != -1) this.list_Message.splice(index, 1)

            }


          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }

  async showMedia(item: any) {

    this.isLoading = true;

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iORGVoiceMessages: item.iORGVoiceMessages

    }

    let res = (await axios.post(`VoiceMessages_GetVoice`, model)).data;

    this.isLoading = false;

    if (res == null) return this.notificationService.showError('خطایی رخ داده است')

    if (res != null) {

      this.clearAudioRecordedData();

      this.audioManager = '';

      setTimeout(() => {

        this.audioManager = res.toString();

        this.openModal('voice');

      }, 500);

    }



  }

  async getSchools() {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    }

    let res = JSON.parse((await axios.post(`School_User_List`, model)).data.toString())

    this.list_Schools = res;

  }

  async newMessage() {

    if (!this.model.strTitle || !this.model.strVoice_Base64) return this.notificationService.showError('لطفا فرم را با دقت تکمیل کنید');

    this.isLoading = true;

    this.model.strVoice_Base64 = this.model.strVoice_Base64.replace('data:audio/wav;base64,', '')

    this.model.iSystemUser = this.gurdService.decrypt(localStorage.getItem('ID')!);

    this.model.strSession = this.gurdService.decrypt(localStorage.getItem('Session')!);

    let res = JSON.parse((await axios.post(`VoiceMessages_Save`, this.model)).data.toString());

    this.list_Message.push(res[0]);

    this.isLoading = false;

    this.model = {};

    this.audioBlobUrl = null;

    this.notificationService.showSuccess('با موفقیت ثبت شد ')

    $('#addMessage').modal('hide');


  }

  filterSchool() {

    if (this.searchT_School == '') {

      this.filteredSchools = [];

      this.iMobileDomain = '';

    }

    else this.filteredSchools = this.list_Schools.filter((item: any) => item.strComment.includes(this.searchT_School));
  }

  ///AudioHandler

  startAudioRecording() {

    navigator.mediaDevices.getUserMedia({ audio: true })

      .then(stream => {

        if (!this.isAudioRecording) {

          this.isAudioRecording = true;

          this.audioRecordingService.startRecording();

        }

      }).catch(err => {

        if (err.message == "Requested device not found")

          this.notificationService.showError("سیستم شما دارای میکروفون نمی باشد")

        else alert("خطا در ضبظ صدا")

      })

  }

  abortAudioRecording() {

    if (this.isAudioRecording) {

      this.isAudioRecording = false;

      this.audioRecordingService.abortRecording();

    }

  }

  stopAudioRecording() {

    if (this.isAudioRecording) {

      this.audioRecordingService.stopRecording();

      this.isAudioRecording = false;

    }

  }

  clearAudioRecordedData() {

    this.audioBlobUrl = null;

    this.model.strVoice_Base64 = "";

  }

  blobToBase64(blob: any) {

    return new Promise((resolve, _) => {

      const reader = new FileReader();

      reader.onloadend = () => resolve(reader.result);

      reader.readAsDataURL(blob);

    });

  }

  searchBy(search: any) {

    if (search.length > 2) {

      this.list_Message = this.list_search.filter((el: any) => {

        return el.strDate.includes(search) || el.strComment.includes(search) || el.strTitle.includes(search) || el.strMobileDomain_strComment?.includes(search)

      })
    }

    else if (search == '') this.list_Message = this.list_search;

  }

  openModal(id: string) {

    $(`#${id}`).modal('show');

  }

  goBack() {

    this.router.navigate(['/'])
  }

}
